export const TranslationsJA = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "オンライン注文",
        cart: "カート",
        open_24: "24時間",
        closed: "クローズ",
        free: "チャージ無し",
        something_went_wrong: "上手くいかなかった時は",
        try_again: "もう一度お試しください",
    },
    constants: {
        calendar: {
            days: {
                monday: "月",
                tuesday: "火",
                wednesday: "水",
                thursday: "木",
                friday: "金",
                saturday: "土",
                sunday: "日",
            },
        },
        services: {
            pickup: "テイクアウト",
            delivery: "イートイン",
            dine_in: "ダイン",
            table_booking: "席予約",
        },
        payment: {
            method: {
                cash: "現金",
                card: "カード",
                stripe: "クレジットカード",
                paypal: "PayPal",
                cardconnect: "クレジットカード",
                paygate_payweb: "ペイゲートペイウェブ",
                poli_pay: "ポリペイ",
                ipay88: "iPay88",
                bambora_apac: "バンボラAPAC",
                pesapal: "ペサパル",
                custom: "カスタム",
            },
            backend_method: {
                cash: "現金",
                card: "カード",
                stripe: "ストライプ",
                paypal: "PayPal",
                cardconnect: "カード接続",
                paygate_payweb: "ペイゲートペイウェブ",
                poli_pay: "ポリペイ",
                ipay88: "iPay88",
                bambora_apac: "バンボラAPAC",
                pesapal: "ペサパル",
                custom: "カスタム",
            },
            status: {
                success: "成功",
                pending: "保留中",
                error: "エラー",
                refunded: "払い戻し済み",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "削除",
                drop_here: "ここにファイルをドロップするか、ファイルを選択して下さい",
                accepts: "{{fileTypes}}ファイルを登録しました",
                errors: {
                    max_files: "最大{{number}}まで登録可能です",
                    max_size: "最大ファイルサイズ{{kilobytes}} KB",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: '営業時間外です',
            },
            buttons: {
                order: {
                    book_order: '席予約/オンライン注文',
                    order_online: 'オンライン注文',
                    book_table: '席を予約する',
                    order: '注文',
                    book: 'メニュー',
                    cart: 'カート',
                    restart: '再起動',
                    closed: '閉店',
                    not_accepting: '注文を受け付けていません',
                },
            },
        },
        modals: {
            auth: {
                login: 'ログインする',
                register: '登録',
                register_commence: '登録',
                register_complete: 'アカウントを作成する',
                register_confirmation_sent: '確認コードがメールアドレスに送信されました。続行するには、下に入力してください',
                register_confirmation_resent: '確認コードが再度送信されました。スパムを確認するか、プロセスを再開してください',
                register_restart: '再起動',
                register_resend_code: 'コードを再送信',
                login_placeholder: 'メールアドレス',
                password_placeholder: 'パスワード',
                confirm_password_placeholder: 'パスワードを認証する',
                confirmation_code_placeholder: 'メール確認コード',
                accept_terms: '利用規約に同意する',
                accept_terms_view: '見る',
                login_facebook: 'Facebookでログイン',
                login_google: 'Googleでログイン',
                benefits: 'ログインするか、アカウントを作成すると注文履歴が確認できます',
                logged_in: 'ログインに成功しました',
                logged_out: 'ログアウト',
                password_reset: {
                    init_button: 'パスワードリセットメールを送信する',
                    init_success: 'パスワードリセットリンクがメールに送信されました',
                    complete_button: 'パスワードを再設定する',
                    complete_success: 'パスワードが正常にリセットされました。新しいパスワードでログインしてください',
                    forgot_password_text: 'パスワードをお忘れですか？ ',
                    forgot_password_link: 'パスワードを再設定する',
                    remember_password_text: 'パスワードを覚えていますか？ ',
                    remember_password_link: '戻る',
                    invalid_title: 'パスワードのリセットが無効です”　→ ”パスワードのリセットができません',
                    invalid_description: 'このパスワードリセットリンクは無効です。代わりに新しいリンクをリクエストしてください',
                    invalid_link: 'ログインに移動',
                    title: 'パスワードのリセット',
                    description: 'アカウントの新しいパスワードを入力してください',
                },
                error_generic: 'エラーが発生しました。もう一度試すか、お問い合わせください',
                error_accept_terms: '利用規約に同意してください',
                error_password_length: 'パスワードは6文字以上',
                error_social: 'エラーが発生しました。もう一度試すか、お問い合わせください',
                error_confirmation_code: '無効な確認コード',
                error_invalid_code: '無効な確認コード',
                error_exists: 'ユーザーはすでに存在しています',
                error_invalid_email_pass: 'メールアドレスまたはパスワードに誤りがあります',
                error_password_no_match: 'パスワードが一致しません',
                error_user_not_found: 'そのメールアドレスのユーザーはいません',
                error_invalid_email: '無効なメールアドレス',
                error_invalid_reset_token: 'リセットリンクが無効です。別のリンクをリクエストしてください',
            },
            booking: {
                form: {
                    name: 'フルネーム',
                    email: 'メールアドレス',
                    phone: '電話番号',
                    number_of_people: '人数',
                    number_of_people_max: '人数（{{max_people}}最大）',
                    number_of_people_min: '人数（{{min_people}}分）',
                    number_of_people_max_min: '人数（B I etween {{min_people}}から{{max_people}}）',
                    notes: '注意事項/コメント',
                    submit: '予約リクエストを送信',
                    email_optional: '（任意）',
                    date: '日付',
                    duration: '所要時間',
                    seating: '予約可能な時間',
                    number_of_guests: '人数',
                    notes_placeholder: 'アレルギー、ご利用目的、席のご希望',
                    reserving: '予約しています...',
                    reserve_table: 'テーブルを予約',
                    please_choose_a_date_and_time: '日付と時間を選択してください。',
                    invalid_people: '人数は{{min}}〜{{max}}名にしてください。',
                    party_size_max_fallback: '上限',
                    loading_available_times: '予約可能な時間を読み込んでいます…',
                    select_a_date_to_see_available_times: '日付を選択すると予約可能な時間が表示されます。',
                    no_times_available_for_this_date: 'この日付に予約可能な時間はありません。別の日を選択してください。',
                    shift: '時間帯',
                    service_times: '営業時間',
                    new_shift: '新しい時間帯',
                    time: '件',
                    times: '件',
                    unavailable: '満席',
                    available: '空きあり',
                    required_name: 'お名前を入力してください。',
                    required_phone: '電話番号を入力してください。',
                    required_email: 'メールアドレスを入力してください。',
                    invalid_email: '有効なメールアドレスを入力してください。',
                    required_terms: '予約する前に利用規約に同意してください。',
                    missing_custom_fields: '必須の質問にすべて回答してください。',
                    reservation_is_unavailable: '予約を受け付けていません。',
                    please_contact_the_restaurant_directly: '店舗に直接お問い合わせください。',
                    almost_done: 'あと少しです',
                    your_details: 'お客様情報',
                    tell_us_who_s_coming: 'ご予約を確定できるよう、ご来店される方を教えてください。',
                    book_your_table: 'テーブルを予約する',
                    choose_a_time_that_works_for_you: 'ご都合の良い時間を選択してください。',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: '予約リクエストを送信すると、あとは店舗が対応します。',
                    select_date: '日付を選択',
                    standard: '標準',
                    minutes: '分',
                    next: '次へ →',
                    back: '← 戻る',
                    accept_terms: '利用規約に同意します。',
                    info_1: '予約が承認または拒否されると、メールが送信されます',
                },
                errors: {
                    not_found: '予約は存在しません。削除された可能性があります',
                    generic: 'エラーが発生しました。ページを更新するか、お問い合わせください',
                    something_went_wrong: '問題が発生しました',
                    accept_terms: '利用規約に同意してください',
                    required_phone: '電話番号を入力してください',
                    required_email: 'あなたのメールアドレスを入力してください',
                    required_name: '名前を入力してください',
                    invalid_email: '有効なメールアドレスを入力してください',
                    invalid_phone: '有効な電話番号を入力して下さい',
                    invalid_people: '無効な人数',
                    booking_capacity_threshold: 'この時間は満席です。別の時間をお試しください。',
                    slot_unavailable: 'この人数では満席です。別の時間をお試しください。',
                    booking_date_paused: 'この日付の予約は一時停止中です。別の日を選択してください。',
                    invalid_table_assignment: 'そのテーブルではご人数を案内できません。別の時間を選択してください。',
                    exceeded_order_limit: '予約リクエストが多すぎます。しばらくしてからもう一度お試しください。',
                    validation_failed_recaptcha_v3: '通常と異なるアクセスを検出しました。VPNを使用していますか？上の確認を完了してもう一度お試しください。',
                    validation_failed_recaptcha_v2: '予約を開始できませんでした。もう一度試すか、別の方法をご利用ください。VPNを使用している場合は、まずオフにしてみてください。',
                    booking_already_exists: 'この予約はすでに送信済みです。メールを確認するか、予約リンクを開いてください。',
                    invalid_party_size: '有効な人数を選択してください。',
                    invalid_request: '無効なリクエストです。ページを更新してもう一度お試しください。',
                    table_booking_unavailable: 'テーブル予約は利用できません。',
                },
            },
            cart: {
                title: 'カート',
                proceed_to_checkout: 'お支払い方法を選択',
                edit_dish: '編集する',
                remove_dish: '削除する',
                no_items_1: 'カートに商品がありません',
                no_items_2: '商品を追加して次に進みます',
                free_delivery_notice: '{{value, currency}}を超えるご注文は無料配送',
                errors: {
                    min_order_promo: 'このプロモーションを適用するために必要な最低注文数{{value, currency}}',
                    min_order_delivery: 'デリバリーの最低注文数{{value, currency}}',
                },
                promo: {
                    heading: 'プロモーションコード',
                    placeholder: 'プロモーションコードを入力してください',
                    add: 'コードを追加',
                    title: 'プロモーション{{name}}がカートに追加されました',
                    fixed_discount: '{{value, currency}} オフ',
                    percent_discount: '{{value}}% オフ',
                    added_to_cart: 'カートにプロモーションを追加しました',
                    errors: {
                        not_found: 'プロモーションが見つかりません',
                        disabled: 'プロモーションが無効になっています',
                        not_available: 'プロモーションは現在ご利用いただけません',
                        logged_in_only: 'このプロモーションを使用するにはログインする必要があります',
                        already_used: 'このプロモーションは既に使用しています',
                        invalid: 'このプロモーションは無効になりました',
                        invalid_service: 'このプロモーションは選択したサービスには無効です',
                        later_only: '予約のみ有効',
                        now_only: '当日注文のみ有効',
                        generic: 'エラーが発生し、ログに記録されました',
                        dishes_required_multi: 'このプロモーションは、特定の料理がカートに追加されたときにのみ適用されます',
                        dishes_required_single: 'このプロモーションは{{dish}}にのみ適用されます',
                    },
                },
                tip: {
                    title: 'チップ',
                    placeholder: 'チップ',
                },
            },
            checkout: {
                title: 'カートに戻る',
                subtitle: 'ご注文内容の確認',
                details: {
                    service: 'サービス',
                    due: '時間',
                    due_now_asap: '即時注文',
                    address: 'お届け先住所',
                    total: '合計',
                    table: 'テーブル',
                    store_location: '店舗の住所',
                },
                customer: {
                    title: 'お客様',
                    subtitle: 'ログインして注文内容を保存します',
                    button: 'ログインする',
                    name: 'フルネーム',
                    email: 'メールアドレス',
                    phone: '電話番号',
                    phone_important: '電話番号 (Important)',
                    notes: 'コメント',
                    delivery_notes: '配達指示/コメント',
                    optional: 'オプション',
                },
                payment: {
                    title: '支払方法',
                },
                accept_terms: '利用規約に同意する',
                accept_terms_view: '見る',
                processing_order: '注文処理',
                warning: {
                    different_payment_currency: '店舗の価格は{{store_currency}}です。支払い方法は{{payment_currency}}です',
                    closing_soon: '間もなく終了します。注文は{{value}}分以内に行う必要があります',
                    closed: '、このサービスは現在ご利用いただけません',
                    expired: '選択した時間は注文ができません。再度、時間を選択してください',
                },
                errors: {
                    stripe_generic: 'クレジットカードエラー、再施工または別の支払方法を選択',
                    stripe_loading_fail: 'お支払いフォームの読み込み中にエラーが発生しました。もう一度お試しください',
                    something_went_wrong: '問題が発生しました',
                    paypal_generic: 'PayPalで問題が発生しました。もう一度試すか、別のお支払い方法を選択してください',
                    payment_fail: 'お支払いに失敗しました。もう一度試すか、別のお支払い方法を選択してください',
                    payment_cancelled: '支払いがキャンセルされました。もう一度試すか、別のお支払い方法を選択してください',
                    payment_error: 'オンライン支払いの処理中にエラーが発生しました。もう一度試すか、別のお支払い方法を選択してください',
                    payment_declined: '指定のお支払い方法はご利用いただけません',
                    card_declined: 'カードエラー、支払いは処理できませんでした',
                    promo_max_uses_exceeded: "このプロモコードは使用上限に達したため、現在はご利用いただけません。",
                    store_closed: '営業時間外です',
                    accept_terms: '利用規約に同意してください',
                    required_payment: 'お支払い方法を選択してください',
                    required_phone: '電話番号を入力してください',
                    required_email: 'あなたのメールアドレスを入力してください',
                    required_name: '名前を入力してください',
                    invalid_email: '有効なメールアドレスを入力してください',
                    invalid_phone: '有効な電話番号を入力して下さい',
                    invalid_cc_number: 'クレジットカード番号が無効です',
                    invalid_order_amount: 'このお支払い方法に必要な最低額',
                    retry_cc_number: 'エラーが発生しました。クレジットカード番号を再入力して、もう一度お試しください',
                    closed: '営業時間外です',
                    promo_login_required: 'このプロモーションを使用するにはログインする必要があります',
                    promo_used: 'このプロモーションは既に使用しています',
                },
                button: {
                    continue: '支払いを続ける',
                    place_order: '注文する',
                },
            },
            customer: {
                age_v: {
                    title: '年齢確認',
                    required_for_items: '特定のアイテムの注文に必要',
                    min_age: '最低年齢：{{age}}歳',
                    est_time: '推定検証時間：{{time}}時間',
                    upload_description: '年齢確認書類をアップロードしてください。確認後、メールで通知されます。最大2MBの画像を2枚アップロードできます',
                    pending_description_1: '書類をご提出いただきありがとうございます。承認されるとメールで通知されます',
                    pending_description_2: '確認ステータスを更新するには、ページを更新してください。推定検証時間は{{time}}時間です',
                    approved_description: 'アカウントが確認され、年齢制限付きメニューの注文ができます',
                    rejected_description: '年齢確認書類が承認されませんでした。もう一度、年齢確認書類をアップロード してください',
                    upload: 'アップロードする',
                    reupload: 'ドキュメントを再アップロード',
                    go_back: '戻る',
                    view_document: 'ドキュメント{{number}}を表示',
                    status: {
                        unverified: '未確認',
                        pending: '承認待ち',
                        approved: '正常に確認されました',
                        rejected: '拒否されました',
                    },
                },
                headings: {
                    sessions: '来店回数',
                    orders: '注文回数',
                    spend: '合計注文額',
                    order_history: '注文履歴',
                    loyalty_points: 'ポイント',
                },
            },
            custom_payment: {
                title: '{{name}}支払いフォーム',
                description: 'オンライン支払いフォームにアクセスしました。お支払いを行うには、以下のフィールドに入力してください。金額を入力しない場合、詳細は保存されますが、請求は行われません。',
                disabled: 'このオンライン決済ページは正しく設定されていません。サイトの所有者に連絡して、問題を修正してください。',
                success: 'お支払いは正常に処理され、詳細が保存されました。ありがとうございました',
                back: '家に帰る',
                fields: {
                    name: 'フルネーム',
                    email: 'メールアドレス',
                    reference: '支払い参照',
                    amount: '金額（）',
                    name_on_card: 'カードの名義',
                    submit: '支払いを送信',
                },
                warning: {
                    currency: '注：お支払い金額は{{default}}ではなく{{actual}}です',
                },
                errors: {
                    generic: 'エラーが発生しました。もう一度試すか、お問い合わせください',
                    stripe_generic: 'クレジットカードエラー、ページを更新してもう一度お試しください',
                    payment_fail: 'お支払いに失敗しました。もう一度試すか、別のお支払い方法を選択してください',
                    payment_cancelled: '支払いがキャンセルされました。もう一度試すか、別のお支払い方法を選択してください',
                    payment_error: 'オンライン支払いの処理中にエラーが発生しました。もう一度試すか、別のお支払い方法を選択してください',
                    payment_declined: '指定のお支払い方法はご利用いただけません',
                    card_declined: 'カードエラー、支払いを処理できませんでした',
                    promo_max_uses_exceeded: "このプロモコードは使用上限に達したため、現在はご利用いただけません。",
                },
            },
            dish: {
                add: 'カートに追加',
                edit: 'アイテムを更新',
                notes: 'コメント',
                ingredients: {
                    title: '材料',
                    uncheck_remove: 'チェックを外して削除',
                },
                ingredients_title: '材料',
                combo: {
                    choose_dish: '料理を選択',
                },
                option_sets: {
                    conditions: {
                        select_one: '1つ選択してください（必須）',
                        select_one_optional: '1つ選択してください（オプション）',
                        select_between: '{{min}} - {{max}} の間で選択（必須）',
                        select_at_least: '少なくとも{{qty}}を選択してください（必須）',
                        select_up_to: '最大{{qty}}を選択します（オプション）',
                        select_multiple: '複数選択（オプション）',
                        free_amount: '最初の{{qty}}無料/ {{selected}}選択済み',
                    },
                },
                error: '赤でマークされたオプションを修正してください',
                added_to_cart: 'カートに追加されたアイテム',
            },
            map: {
                zone_fee: '配送料',
                view_in_google: 'グーグルマップで見る',
            },
            portal_go_back: {
                title: 'レストラン検索に戻る',
                description: 'カート内のアイテムはすべて空になります',
                cancel: 'キャンセル',
                proceed: '戻る',
            },
            order: {
                config: {
                    services: {
                        title: 'サービスを選択',
                        table_booking: '席予約',
                    },
                    address_custom: {
                        input_placeholder: '住所を入力してください',
                    },
                    address: {
                        input_placeholder: '配送先住所を検索',
                        extras_placeholder: 'オプション：ユニット番号、建物名など...',
                        search_placeholder: '住所を検索',
                        not_found: '配送先住所が見つからないか、有効ではありません。もう一度お試しください',
                        not_delivering: '現在、この住所には配達していません',
                        not_in_range: '指定の住所は配達範囲外です',
                        not_in_zone: '指定の住所は配達範囲外です',
                    },
                    datetime: {
                        title: 'ご注文はいつですか',
                        due_now: '今',
                        due_later: '後で',
                        service_not_available: '現在、{{service}}の注文は受け付けておりません',
                        currently_closed: '{{service}}は現在ご利用いただけません。営業時間をご確認ください',
                        due_unavailable: "利用できません",
                        due_closed: "閉店",
                        select_date: "日付を選択",
                        select_time: "時間を選択",
                        select_order_date: "ご注文日を選択してください",
                        select_order_time: "ご注文時間を選択してください",
                        select_booking_date: "予約日を選択してください",
                        select_booking_time: "予約時間を選択してください",
                        no_times_available: "選択できる時間はありません",
                        date_today: "（今日）",
                        date_closed: "(閉店)",
                        date_bookings_paused: "（予約一時停止）",
                        time_slot_closed: "閉店",
                    },
                    number_of_people: {
                        placeholder: "人数",
                    },
                    table: {
                        select: "テーブルを選択",
                        select_popup_title: "テーブルを選択してください",
                        password: "テーブルパスワード",
                        password_warning: "続行するにはテーブルのパスワードを入力してください",
                    },
                    warning: {
                        closed: "営業時間外です",
                        not_available: "現在、ご注文は受け付けておりません",
                    },
                    start_button: "開始注文",
                },
                history: {
                    invalid: "注文したアイテムの一部が変更されたか、利用できなくなったため、再注文できません",
                },
                reorder: {
                    title: "クイック再注文",
                    description: "注文履歴から商品を再度注文する",
                },
            },
            receipt: {
                errors: {
                    not_found: "注文が見つかりません。ページを更新して、もう一度お試しください",
                    booking_not_found: "予約が存在しません。削除された可能性があります",
                    generic: "エラーが発生しました。ページを更新するか、お問い合わせください",
                },
                connection: {
                    connected: "リアルタイムの更新",
                    connecting: "接続中",
                    disconnected: "未接続",
                },
            },
            warnings: {
                logout: {
                    pretitle: "警告",
                    title: "ログアウト",
                    body: "ログアウトすると、カートに追加されたアイテムがすべて削除されます",
                    cancel: "キャンセル",
                    proceed: "続行する",
                },
                order_restart: {
                    warning: "警告",
                    title: "注文詳細の変更",
                    body: "特定の料理が利用できなくなる可能性があるため、注文の詳細を変更すると、カート内のアイテムが削除されます",
                    cancel: "キャンセル",
                    proceed: "続行する",
                },
                order_expired: {
                    subtitle: "重要",
                    title: "注文は直ちに期限に変更されました",
                    description: "あなたの注文のために選択された時間は今ではそれほど遠くないです。そのため、ご注文はすぐに期限が切れるように変更されました/至急",
                    button: "Ok",
                },
                order_expiring: {
                    subtitle: "重要",
                    title: "注文期限が間もなく期限切れ",
                    description: "ご注文は{{time、timeFromTimestamp}}より前に行う必要があります。それ以外の場合は無効になります",
                    button: "Ok",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "ゲスト",
                login: "ログイン",
                login_signup: "ログイン／サインアップ",
                logout: "ログアウト",
            },
            menus: {
                info: {
                    no_menus: "現在利用可能なメニューはありません",
                    restrictions: "メニュー",
                    not_available: "現在利用できないメニュー",
                    unavailable: {
                        times: "メニューは利用できません。注文要件が以下と一致しません",
                        services: "メニューは利用できません。注文要件が以下と一致しません",
                        hours: "メニューはご利用いただけません、ご注文時間はこのメニューのご利用時間内ではありません",
                        pre_order: "メニューはご利用いただけません。ご注文内容は予約購入の要件を満たしていません",
                        age: "メニューを利用できません。このメニューから注文するには、年齢確認済みのアカウントでログインする必要があります",
                    },
                    services: {
                        title: "注文",
                        pickup: "テイクアウト",
                        delivery: "デリバリー",
                        dine_in: "イートイン",
                    },
                    times: {
                        now: "予約なし",
                        later: "予約のみ",
                    },
                    hours: {
                        title: "利用可能な時間",
                    },
                    preorder: {
                        title: "予約注文の要件",
                        days_in_advance: "{{days}}日前に注文する必要があります",
                        cutoff_time: "最終日の締め切り時刻{{time、timeFromTime}}",
                    },
                    age_restricted: {
                        title: "年齢制限あり",
                        approved: "アカウントが確認され、このメニューから注文できます",
                        rejected: "注文するには年齢確認が必要です。アカウントを作成して年齢確認書類をアップロード",
                    },
                },
            },
            info: {
                location: {
                    title: "マップ",
                    view_map: "地図を見る",
                    phone: "電話",
                },
                hours: {
                    title: "営業時間",
                    title_special: "特別営業時間",
                },
                services: {
                    title: "サービス",
                    notes: "コメント",
                    delivery: {
                        ranges: "配達範囲",
                        zones: "配達範囲",
                        view_zones: "地図上に配達エリアを表示",
                        fee: "配送料",
                        fee_short: '料金',
                        fee_varies: "カートに表示",
                        min_order: "最小注文",
                        min_order_short: '最低',
                        no_min_order: "最低注文なし",
                        free_amount: "無料配達額",
                    },
                },
            },
            contact: {
                title: "お問い合わせ",
                name: "名前",
                email: "メールアドレス",
                phone: "電話番号",
                message: "メッセージを入力してください...",
                send: "メッセージを送る",
                success: "メッセージを送信しました",
                error: "問題が発生しました。もう一度試すか、後で実行してください",
            },
            footer: {
                powered_by: "提供",
                terms_and_conditions: "利用規約",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: '予約領収書',
            details: {
                datetime: '予約',
                number_of_people: '人数',
                placed: '注文',
                updated: '最終更新',
                notes: 'コメント',
                name: '名前',
                email: 'メールアドレス',
                phone: '電話',
                store_address: '店舗の住所',
            },
            status_update: {
                title: '予約{{number}}が更新されました',
                body: '予約ステータスが{{status}}に更新されました',
            },
            email_status_update_customer: {
                subject: '予約 #{{number}} – {{subjectLabel}}',
                body: '{{store}}のご予約 #{{number}} は現在{{status}}です。',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: '注文 #{{number}} – {{subjectLabel}}',
        header: '準備完了時間の更新',
        title: '準備完了時間の更新',
        order_number: '注文番号: {{number}}',
        description: 'ご注文は{{time}}に準備完了となります。',
        order_time_updated_to: 'ご注文の時間が更新されました。',
        powered_by: '搭載 {{name}}',
        button_text: '注文の追跡',
        subject_label: '準備完了時間の更新',
        subject_label_delivery: '配達時間の更新',
        body_ready: 'ご注文は{{time}}に準備完了となります。',
        body_delivery: 'ご注文は{{time}}にお届けします。',
    },
    order: {
        receipt: {
            est_ready_time: '準備時間',
            est_driver_pickup_time: '23/5000EST（東部基準時。 ドライバーピックアップ時間',
            est_delivery_time: 'お届け時刻',
            tab_details: '注文内容',
            tab_dishes: '料理',
            details: {
                status: '状態',
                placed: '注文',
                due: '時間',
                due_asap: '即時注文',
                last_updated: '最終更新',
                total: '合計',
                type: 'タイプ',
                table: 'テーブル',
                number_of_people: '人数',
                payment_method: '支払方法',
                payment_status: '支払い状況',
                payment_currency: '支払い通貨',
                notes: '名前',
                name: '名前',
                email: 'メールアドレス',
                phone: '電話',
                distance: '距離',
                driving_time: '運転時間',
                delivery_zone: '配達エリア',
                delivery_address: '配送先住所',
                delivery_tracking: '配送追跡',
                delivery_tracking_link: 'リアルタイム追跡リンク',
                tookan_status: '配達状況',
                tookan_status_failed_book: '配達の予約に失敗しました',
                tookan_status_failed_update: '予約を更新できませんでした',
                tookan_status_success: '配達予約済み',
                store_address: '店舗の住所',
            },
            dishes: {
                headings: {
                    quantity: '数量',
                    item: '項目',
                    price: '価格',
                },
                notes: 'コメント',
                remove_ingredients: '成分を取り除く',
            },
            status_update: {
                title: '注文{{number}}が更新されました',
                body: '注文ステータスが{{status}}に更新されました',
            },
            wait_time_update: {
                title: '注文{{number}}が更新されました',
                body: 'ご注文期限が更新されました',
            },
            delivery_update: {
                title: '注文{{number}}が更新されました',
                body: 'ご注文は配送のために予約されています。 リアルタイムの追跡リンクを見る',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "注文を追跡する",
                track_delivery_button_text: "配達を追跡する",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "注文を追跡する",
                track_delivery_button_text: "配達を追跡する",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. in price",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "配送料",
            promo: "Discount: {{name}} ({{value, currency}} + {{percent}}% Off)",
            promo_percent: "ディスカウント: {{name}} ({{percent}}%)",
            promo_fixed: "ディスカウント: {{name}}",
            promo_none: "ディスカウント: {{name}}",
            cart: "カート",
            tip: "チップ",
            total: "合計",
        },
        status: {
            unconfirmed: "未確認",
            awaiting_payment: "支払いを待っている",
            confirmed: "確認済み",
            ready: "準備ができました",
            on_route: "ルート上",
            complete: "コンプリート",
            cancelled: "キャンセル",
            seated: "着席済み",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "利用できません",
                },
            },
            dish: {
                no_stock: "在庫切れ",
                not_available: "利用不可",
            },
        },
    },
};
//# sourceMappingURL=ja.js.map